<template>
  <div>
    <div class="l-paging">
      <a v-show="pageInfo.currentPage > 1" :class="{disabled: pageInfo.currentPage <= 1}" class="l-paging__prev" @click="change(pageInfo.currentPage - 1)">前へ</a>
      <a v-for="page in pages" :key="page" class="l-paging__number" :class="{'is-current': page === pageInfo.currentPage}" @click="change(page)">
        {{page}}
      </a>
      <a v-show="pageInfo.currentPage < pageInfo.lastPage" :class="{disabled: pageInfo.currentPage >= pageInfo.lastPage}" class="l-paging__next" @click="change(pageInfo.currentPage + 1)">次へ</a>
    </div>
    <p class="l-paging__bottom-txt">{{pageInfo.total}}件中 {{pageInfo.from}}〜{{pageInfo.to}}件を表示中</p>
  </div>
</template>

<script>
//import _ from 'lodash'
import { max, min, range } from 'lodash'

export default {
  name: 'Pagination',
  props: {
    pageInfo: {
      type: Object,
      'default': () => ({
        currentPage: 1,
        lastPage: 1,
        total: 1,
        from: 0,
        to: 0
      })
    }
  },
  methods: {
    change(page) {
      this.$emit('change-page', (page));
    }
  },
  computed: {
    pages() {
      let start = max([this.pageInfo.currentPage - 2, 1])
      let end = min([start + 5, this.pageInfo.lastPage + 1])
      start = max([end - 5, 1])
      return range(start, end)
    }
  },
}
</script>
